
import './App.css';
import TodoBody from './components/TodoBody';
import { ToastProvider } from './contexts/TostContext';
import TodosProvider from './contexts/TodoContext';



function App() {
  
  return (
    <TodosProvider>
      <ToastProvider>
        <div className="App">
            <TodoBody />
        </div>
      </ToastProvider>  
    </TodosProvider>
  );
}

export default App;
